import React from 'react';
import LegalPage from './LegalPage';

const TermsOfService = () => (
  <LegalPage file="terms-of-service" logLabel="Terms of Service" />
);

export default TermsOfService;
